import { Box, IconButton, TextFieldProps, Typography } from '@mui/material';
import { FC } from 'react';
import { InfoIcon, LockIcon, WarningIcon } from '../../../../icons';
import { TooltipComponent } from '../../feedback';
import { t } from 'i18next';

type Props = {
  label: TextFieldProps['label'];
  required?: boolean;
  futureEditingLocked?: boolean;
  missing?: boolean;
  missingMessage?: string;
  tooltip?: string;
  disabled?: boolean;
  showTooltipOnDisabled?: boolean;
};

export const InputFieldLabel: FC<Props> = ({
  label,
  required,
  futureEditingLocked,
  missing,
  missingMessage,
  tooltip,
  disabled,
  showTooltipOnDisabled
}) => {
  return (
    <Box display="flex">
      <Typography
        flex={1}
        variant="body2"
        sx={(theme) => ({
          marginBottom: '8px',
          color: disabled ? theme.palette.grey['200'] : theme.palette.grey['600']
        })}
      >
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {label}
          {required && '*'}
          {futureEditingLocked && (
            <TooltipComponent arrow placement="right" title={t('custom:lock_tooltip')}>
              <span style={{ marginTop: '-4px', marginLeft: '4px' }}>
                <LockIcon width={17} />
              </span>
            </TooltipComponent>
          )}
          {tooltip && (
            <TooltipComponent
              title={tooltip}
              arrow
              placement="top"
              showOnDisabled={showTooltipOnDisabled}
            >
              <IconButton disabled={disabled} className="p-0 h-3 ml-1">
                <InfoIcon className={`h-3 w-3 ${disabled ? 'text-grey-200' : 'text-grey-600'}`} />
              </IconButton>
            </TooltipComponent>
          )}
        </span>
      </Typography>
      {missing && missingMessage && (
        <TooltipComponent title={missingMessage} placement="left" arrow>
          <Box height="18px" width="18px" paddingRight={1}>
            <WarningIcon height={18} width={18} color="grey.500" />
          </Box>
        </TooltipComponent>
      )}
    </Box>
  );
};
